
const EqualizeHeights = {

	elements: {},

	getGroups(container)
	{
		const groups = [[]];
		const containerWidth = container.offsetWidth;
		const headers = container.querySelectorAll('.js-equalize-height');
		const headerWidth = headers[0].offsetWidth;
		const perRow = Math.floor( containerWidth / headerWidth );

		let groupIndex = 0;
		let headerIndex = 0;

		Array.prototype.forEach.call(headers, (header) => {

			// when the group is full, increment to the next row index
			if( headerIndex % perRow === 0 && headerIndex !== 0 )
			{
				groupIndex += 1;
				groups[groupIndex] = [];
			}

			groups[groupIndex].push(header);

			headerIndex += 1;
		});

		return groups;
	},

	equalize()
	{
		Array.prototype.forEach.call(this.elements.containers, (container) => {

			const groups = this.getGroups(container);

			groups.forEach( (group) => {
				let height = 0;

				// find the tallest item
				group.forEach( (header) => {
					header.removeAttribute('style');
					height = header.offsetHeight > height ? header.offsetHeight : height;
				});


				// apply that height to all items in this row
				group.forEach( (header) => {
					header.style.height = height + "px";
				});

			});
		});

		/*Array.prototype.forEach.call(this.elements.containers, (container) => {

			const containerWidth = container.offsetWidth;
			const headers = container.querySelectorAll('.js-equalize-height');
			const groups = [];

			Array.prototype.forEach.call(headers, (header) => {

			});
		});*/
	},

	bind()
	{
		if( this.elements.containers )
		{
			this.equalize();

			window.addEventListener('resize', () => {this.equalize()} );
		}
	},

	cacheDom()
	{
		this.elements.containers = document.querySelectorAll('.js-equalize-heights');
	},

	init()
	{
		this.cacheDom();
		this.bind();
	}
};

export default EqualizeHeights;